import { useTranslate } from '@refinedev/core';
import { useTable } from '@refinedev/antd';
import { Flex, theme } from 'antd';
import { EmbeddedTableSearch } from '@/components/common/EmbeddedTableSearch';
import type { WithdrawalContractOut } from '@/api/generated/schemas';
import { WithdrawalContractsTable } from '@/components/monetization/withdrawal_contracts/WithdrawalContractsTable';

interface CustomerWithdrawalContractsTableProps {
  accountId: number;
}

export const CustomerWithdrawalContractsTable = ({
  accountId,
}: CustomerWithdrawalContractsTableProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();
  const { tableProps, sorters, setFilters } = useTable<WithdrawalContractOut>({
    resource: 'monetization.withdrawal_contracts',
    filters: {
      permanent: [{ field: 'account_id', operator: 'eq', value: accountId }],
    },
    sorters: { initial: [{ field: 'id', order: 'desc' }] },
    pagination: { pageSize: 10 },
    syncWithLocation: false,
  });
  return (
    <Flex vertical gap={token.marginSM}>
      <EmbeddedTableSearch
        setFilters={setFilters}
        placeholder={t('monetization.withdrawal_contracts.search.placeholder')}
      />
      <WithdrawalContractsTable tableProps={tableProps} sorters={sorters} />
    </Flex>
  );
};
